var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8281 2V12C15.8281 13.1 14.9281 14 13.8281 14H2.82812V7.62C3.55813 8.49 4.67815 9.03 5.91815 9C6.92815 8.98 7.83813 8.59 8.51813 7.94C8.82813 7.68 9.08815 7.34999 9.28815 6.98999C9.64815 6.37999 9.84812 5.65997 9.82812 4.90997C9.79813 3.73997 9.27814 2.71 8.46814 2H15.8281Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8281 14V17C22.8281 18.66 21.4881 20 19.8281 20H18.8281C18.8281 18.9 17.9281 18 16.8281 18C15.7281 18 14.8281 18.9 14.8281 20H10.8281C10.8281 18.9 9.92813 18 8.82812 18C7.72812 18 6.82812 18.9 6.82812 20H5.82812C4.16813 20 2.82812 18.66 2.82812 17V14H13.8281C14.9281 14 15.8281 13.1 15.8281 12V5H17.6682C18.3882 5 19.0481 5.39001 19.4081 6.01001L21.1181 9H19.8281C19.2781 9 18.8281 9.45 18.8281 10V13C18.8281 13.55 19.2781 14 19.8281 14H22.8281Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82812 22C9.93269 22 10.8281 21.1046 10.8281 20C10.8281 18.8954 9.93269 18 8.82812 18C7.72356 18 6.82812 18.8954 6.82812 20C6.82812 21.1046 7.72356 22 8.82812 22Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8281 22C17.9327 22 18.8281 21.1046 18.8281 20C18.8281 18.8954 17.9327 18 16.8281 18C15.7236 18 14.8281 18.8954 14.8281 20C14.8281 21.1046 15.7236 22 16.8281 22Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8281 12V14H19.8281C19.2781 14 18.8281 13.55 18.8281 13V10C18.8281 9.45 19.2781 9 19.8281 9H21.1181L22.8281 12Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82927 4.90975C9.84927 5.65975 9.6493 6.37977 9.2893 6.98977C9.0893 7.34977 8.82928 7.67978 8.51928 7.93978C7.83928 8.58978 6.9293 8.97978 5.9193 8.99978C4.6793 9.02978 3.55927 8.48977 2.82927 7.61977C2.68927 7.46977 2.56928 7.29978 2.45928 7.12978C2.06928 6.53978 1.84927 5.8398 1.82927 5.0898C1.79927 3.8298 2.35927 2.67977 3.25927 1.92977C3.93927 1.36977 4.79925 1.01978 5.73925 0.999776C6.78925 0.979776 7.74929 1.35978 8.46929 1.99978C9.27929 2.70978 9.79927 3.73975 9.82927 4.90975Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83057 4.52295C6.43814 4.52295 6.93067 4.03042 6.93067 3.42285C6.93067 2.81529 6.43814 2.32275 5.83057 2.32275C5.223 2.32275 4.73047 2.81529 4.73047 3.42285C4.73047 4.03042 5.223 4.52295 5.83057 4.52295Z",
    fill: "#1C1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82811 5.07324C4.72581 5.07324 3.82812 5.81251 3.82812 6.72339C3.82812 6.785 3.87653 6.8334 3.93813 6.8334H7.71808C7.77968 6.8334 7.82809 6.785 7.82809 6.72339C7.82809 5.81251 6.93041 5.07324 5.82811 5.07324Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.bc36eac35ba42d538f9747b1b50d7c54.svg";
export { ForwardRef as ReactComponent };